import React, { useState } from "react";

import { Content } from "./style";
import './style.css';

import Sidebar from "./sidebar.jsx";
import FileUploadToast from "../header/file-upload-toast";

function Layout(props) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>

      <div style={{ height: '100vh' }} className="d-flex w-100">
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
        <Content>
          <div
            style={{ height: '100%' }}
            className={collapsed ? "collapsed" : "collapsed-none"}
          >
            {props.currentComponent}
          </div>
        </Content>
      </div>
      <FileUploadToast />
    </>
  );
}

export default Layout;
